import {
  Component,
  h,
  Prop,
  Host,
  ComponentInterface,
  Event,
  EventEmitter,
  Element,
} from '@stencil/core';

@Component({
  tag: 'signet-switch',
  styleUrl: 'signet-switch.scss',
})
export class Switch implements ComponentInterface {
  @Element() el!: HTMLElement;

  switchId = `switch_${switchIds++}`;

  /**
   * The name of the switch.
   * This is used to identify the switch when it is submitted in a form.
   * It is also used as the id of the input element.
   * It is recommended to use a unique name for each switch.
   * If not provided, a unique name will be generated.
   * @example "switch1"
   * @example "switch2"
   */
  @Prop() name: string;
 /**
  * `disabled` indicates whether the switch is disabled or not.
  * If the switch is disabled, it cannot be clicked or changed.
  * The default value is `false`, which means the switch is enabled.
  * @example true
  */
  @Prop() disabled = false;
  /**
   * `checked` indicates whether the switch is checked or not.
   * It is a mutable property, which means it can be changed by the user.
   * It is recommended to use a unique name for each switch.
   * If not provided, a unique name will be generated.
   */
  @Prop({ mutable: true }) checked = false;

  @Event() changeEvent: EventEmitter;

  private clickHandler() {
    if (this.disabled) return;

    this.checked = !this.checked;

    this.changeEvent.emit({
      value: this.checked,
    });

    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: this.checked
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: this.checked
    }));
  }

  render() {
    const classes = {
      'signet-switch': true,
      disabled: this.disabled,
    };

    return (
      <Host class={classes}>
        <label class="toggle-switch" htmlFor={this.name}>
          <input
            type="checkbox"
            checked={this.checked}
            onChange={() => this.clickHandler()}
            readOnly
            disabled={this.disabled}
            name={this.name}
            id={this.name}
          />
          <span
            class={`${this.disabled ? 'disabled' : ''} slider round`}
          ></span>
        </label>
      </Host>
    );
  }
}

let switchIds = 0;
